export enum PopUpType {
  ALERT = 'alert',
  CONFIRM = 'confirm',
  PROMPT = 'prompt',
  SELECT = 'select'
}
